export const app_i18n = {
  text1:
    "Zeskanuj tylną stronę dowodu osobistego lub stronę paszportu ze zdjęciem",
  text2: "Czy ma Pan/Pani problem ze skanerem?",
  text3: "Spróbuj ponownie",
  text4: "Proces ręczny",
  text5: "Witamy!!",
  text6: "Wybierz datę pobytu",
  text7: "Adres e-mail",
  text8: "Dalej",
  text9: "Jeszcze chwila, prawie gotowe",
  text10: "Witamy",
  text11: "Witamy",
  text12: "Telefon",
  text13:
    "Aby kontynuować, należy zaakceptować nasz regulamin.",
  text14: "Akceptuję regulamin",
  text15: "Dalej",
  text16: "Podpis można złożyć w szarym polu widocznym na ekranie",
  text17: "Wyczyść",
  text18: "Zapisz podpis",
  text19: "Prosimy złożyć podpis",
  text20: "Check-in zakończony pomyślnie",
  text21:
    "Dziękujemy bardzo, kopię podpisanego dokumentu wysłaliśmy na Państwa WhatsApp",
  text22: "Trzeba wykonać kolejny check-in?",
  text23: "Zacznij od nowa",
  text24: "Witamy  🤗",
  text25: "😃 Prosimy wprowadzić poniższe dane",
  text26: "Imię",
  text27: "Nazwisko",
  text28: "Wybierz płeć",
  text29: "Płeć",
  text30: "Mężczyzna",
  text31: "Kobieta",
  text32: "Data urodzenia",
  text33: "Jeszcze chwila, prawie gotowe 😉",
  text34: "Wybierz datę pobytu.",
  text35: "E-mail",
  text36: "Wpisz numer dokumentu",
  text37: "Rodzaj dokumentu",
  text38: "DOWÓD OSOBISTY",
  text39: "PASZPORT",
  text40: "Wpisz numer dokumentu",
  text41: "Należy wybrać kraj",
  // here
  text42: "Kraje",
  text43: "Lista dostępnych usług obiektu",
  text44: "Wczytywanie usług ...",
  text45: "Brak dostępnych usług",
  text46: "Zgłoszenie usługi wysłane pomyślnie",
  text47: "Pracownik skontaktuje się z Państwem, aby sfinalizować zgłoszenie usługi.",
  text48: "Wstecz",
  text49:
    "Zgłoszenie usługi wysłane pomyślnie, wkrótce skontaktuje się z Państwem opiekun.",
  text50: "Cena",
  text51: "Opis usługi",
  text52: "Zamów",
  text53: "Wyślij zgłoszenie usługi",
  text54: "Po wysłaniu zgłoszenia skontaktuje się z Państwem opiekun",
  text55: "Wyślij",
  text56: "Zgłoszenie usługi wysłane pomyślnie.",
  text57: "Błąd, nie udało się zamówić usługi",
  text58: "Wysyłanie danych check-in, prosimy czekać...",
  text59: "Wczytywanie...",
  text60: "ukończył check-in pomyślnie.",
  text61: `🎁 Kliknij tutaj, aby zobaczyć wszystkie nasze usługi dostępne w hotelu`,
  text62: "Rejestracja przyjazdu",
  text63: "Wolę nie podawać",
  text64: "Inna",
  text65: "Kraj",
  text66: "Błąd",
  text67: "Obiekt dezaktywowany.",
  text68: "Właściciel wyłączył check-iny.",
  text69: "Wybierz datę",
  text70: "Od - Do",
  text71: "Wybierz opcję",
  text72: "Wybierz kraj *",
  text73: "Czy na pewno chcą Państwo rozpocząć proces od nowa",
  text74: "Zapisane dane zostaną utracone",
  text75: "Dane check-in",
  text76: "Podpis check-in",
  text77: "Podpisano",
  text78: "Witamy",
  text79: "Przepraszamy, podczas wylogowywania wystąpił błąd",
  text80: "Anuluj proces.",
  text81:
    "Utworzenie pierwszego obiektu jest obowiązkowe dla prawidłowego działania systemu.",
  text82: "Anuluj i wyjdź",
  text83: "Kontynuuj edycję",
  text84: "Szukaj...",
  text85: "Nie znaleziono wpisów",
  text86: "Poprzednia",
  text87: "Następna",
  text88: "Chcą Państwo spróbować ponownie czy przejść do procesu ręcznego?",
  text89: "Wczytywanie ...",
  text90: "Usługi",
  text91: "Data wydania dokumentu",
  text92: "Pole Data wydania dokumentu jest wymagane",
  p93: `wczytywanie...`,
  p94: `Dane rezerwacji`,
  p95: `Witamy`,
  p96: `Aby kontynuować check-in, prosimy wprowadzić poniższe
    dane:`,
  p97: `Ten proces jest demonstracją, żadne Państwa dane nie zostaną zapisane`,
  p98: `Kod bezpieczeństwa:`,
  p99: `Kod bezpieczeństwa obiektu`,
  p101: `Wpisz kod bezpieczeństwa`,
  p102: `Kod bezpieczeństwa jest nieprawidłowy, prosimy sprawdzić i spróbować
    ponownie.`,
  p103: `Można również`,
  p104: `Filtruj według kodu check-in`,
  p105: `Dalej`,
  p106: `Kod check-in`,
  p107: `Wpisz kod check-in`,
  p108: `Kod check-in nie jest zarejestrowany na naszej platformie, prosimy sprawdzić i spróbować ponownie.`,
  p109: `Wpisz kod obiektu`,
  p110: `Ekologiczny check-in`,
  p111: `Witamy!`,
  p112: `Prosimy przygotować`,
  p112_1: `dowód osobisty lub paszport`,
  p112_2: `, aby przejść dalej`,
  p113: `Trzeba będzie zaakceptować`,
  p114: ` uprawnienia do kamery 📷`,
  p115: ` są one niezbędne do prawidłowego działania naszego skanera.`,
  p116: `Dalej`,
  p117: `Wybierz język`,
  p118: `Wpisz kod bezpieczeństwa`,
  p119: `Zeskanuj stronę paszportu lub tylną stronę dowodu osobistego.`,
  p120: `dowodu osobistego`,
  p121: `dowodu`,
  p122: `lub stronę paszportu, na której znajduje się zdjęcie`,
  p123: `Aby korzystać ze skanera, należy przyznać odpowiednie uprawnienia
    do kamery.`,
  p124: `Weryfikacja bezpieczeństwa ​🔐`,
  p125: `Aby zweryfikować Państwa numer, wysłaliśmy kod na`,
  p126: `WhatsApp`,
  p127: `Wpisz go tutaj:`,
  p128: `Wpisz kod`,
  p129: `Nieprawidłowy kod, prosimy sprawdzić i spróbować ponownie`,
  p130: `Wstecz`,
  p131: `Dalej`,
  p132: `Data przyjazdu`,
  p133: `Data wyjazdu`,
  p134: `Data ważności`,
  p135: `Narodowość`,

  p136: `Klikając`,
  p137: ` wyrażają Państwo zgodę na podpisanie formularza swoim imieniem i nazwiskiem oraz umowy najmu krótkoterminowego`,
  p138: `Polityka prywatności`,
  p139: `Zapisz podpis`,
  p140: `Informacje o rezerwacji`,
  p141: `REZERWACJA:`,
  p142: `Przyjazd`,
  p143: `Wyjazd`,
  p144: `Zapłać`,
  p145: `Opłacone`,
  p146: `Weryfikacja płatności`,
  p147: `Check-in`,
  p148: `Rezerwacja`,
  p149: `Usługi`,
  p150: `WERYFIKACJA TOŻSAMOŚCI`,
  p151: `Prosimy przesłać selfie twarzy przy dobrym oświetleniu`,
  p152: `W tym widoku można przesłać zdjęcie <strong>przedniej strony dowodu`,
  p153: `W tym widoku można przesłać zdjęcie <strong>tylnej strony dowodu`,
  p154: `Otwórz kamerę`,
  p155: `Zrób ponownie`,
  p156: `Zweryfikuj tożsamość`,
  p157: `Dalej`,
  p158: `Błąd weryfikacji tożsamości.`,
  p159: `Prosimy spróbować ponownie.
    Zdjęcia najlepiej robić w dobrze oświetlonym miejscu i dokładnie wyśrodkować dokument.`,
  p160: `Proces jest obowiązkowy*`,
  p161: `Spróbuj ponownie`,
  p162: `Weryfikacja tożsamości.`,
  p163: `Prosimy czekać ....`,
  p164: `Tożsamość zweryfikowana pomyślnie`,
  p165: `Tożsamość 🪪 została zweryfikowana pomyślnie, proces check-in jest prawie ukończony 😎`,
  p166: `Do ustalenia`,
  p167: `Aby zamówić tę usługę, należy wykonać check-in.`,
  p168: `Postęp`,
  p169: `Data ważności dokumentu`,
  p170: `Data przyjazdu`,
  p171: `Data wyjazdu`,
  p172: `Telefon`,
  p173: `Nie udało się zeskanować dokumentu.`,
  p174: `Ten adres nie należy do żadnej rezerwacji w systemie`,
  p175: `Informacje o check-in`,
  p176: `Pomoc`,
  p177: `Hiszpański (Hiszpania)`,
  p178: `Angielski`,
  p179: `Arabski`,
  p180: `Dowód osobisty`,
  p181: `Paszport`,

  p182: `Wybierz pokrewieństwo`,
  p183: `Syn/córka`,
  p184: `Dziadek/babcia`,
  p185: `Pradziadek/prababcia`,
  p186: `Prawnuk/prawnuczka`,
  p187: `Szwagier/szwagierka`,
  p188: `Małżonek/małżonka`,
  p189: `Brat/siostra`,
  p190: `Wnuk/wnuczka`,
  p191: `Inne`,
  p192: `Ojciec lub matka`,
  p193: `Siostrzeniec/siostrzenica`,
  p194: `Teść/teściowa`,
  p195: `Wujek/ciocia`,
  p196: `Opiekun prawny`,
  p197: `Zięć/synowa`,

  p198: `Pole pokrewieństwo jest wymagane`,
  p199: `Dowód osobisty`,
  p200: `INNY`,
  p201: `Numer nośnika dokumentu`,
  p202: `Numer nośnika dokumentu jest wymagany`,

  p203: `Informacje wymagane na mocy dekretu królewskiego 933/2021`,
  p204: `Na mocy dekretu królewskiego 933/2021 z 26 października musimy zbierać dane takie jak adres, kod pocztowy, metoda płatności i data płatności, aby spełnić wymogi przepisów bezpieczeństwa.`,
  p205: `Aktualny adres zamieszkania`,
  p206: `Adres`,
  p207: `Kod pocztowy`,
  p208: `Metoda płatności`,
  p209: `Wybierz metodę płatności`,
  p210: `Gotówka`,
  p211: `Płatność na miejscu`,
  p212: `Karta kredytowa`,
  p213: `Płatność mobilna`,
  p214: `Platforma płatnicza`,
  p215: `Karta podarunkowa`,
  p216: `Przelew`,
  p217: `Data płatności`,
  p218: `Metoda płatności`,
  p219: `Data płatności`,
  p220: "Kraj zamieszkania",
  p221: "Miasto zamieszkania",
  p222: "Adres zamieszkania",
  p223: "Kod pocztowy miejsca zamieszkania",

  p224: "Wybierz opcję",
  p225: "Czy w rezerwacji są osoby niepełnoletnie?",
  p226: "Nie",
  p227: "Tak",
  p228: "Dokument niedozwolony",
  p229: "Prosimy sprawdzić i użyć ważnego paszportu, aby kontynuować.",
  p230:`Zeskanuj paszport lub dowód osobisty`,
  
  p231: `Data wyjazdu nie może być wcześniejsza niż data przyjazdu`,
  p232: `Prawidłowy adres e-mail`,
  p233: `Pole wymagane`,
  p234: `Numer dokumentu jest nieprawidłowy`,
  p235: `Data wyjazdu nie może być wcześniejsza niż data wyjazdu`,
  p236: `Należy określić, czy w rezerwacji są dzieci`,
  p237: `Należy wybrać pokrewieństwo, gdy w rezerwacji są dzieci`,
  p238: `Błąd, nie można kontynuować procesu`,
  p239: `Witamy!`,
  p240: `Prosimy przygotować`,
  p241: `dowód osobisty lub paszport`,
  p242: `🪪 do procesu automatycznego`,
  p243: `Uwaga`,
  p244: `Akceptacja uprawnień do kamery 📷`,
  p245: `jest niezbędna do prawidłowego działania naszego skanera`,
  p246: `Zeskanuj tylną stronę`,
  p247: `Tutaj można dokończyć rejestrację check-in!`,
  p248: `Link skopiowany do schowka`,
  p249: `Zarejestruj kolejnego gościa`,
  p250: `WhatsApp`,
  p251: `Kopiuj link`,
  p252: `Nieznana metoda płatności`,
  p253: `Nie znaleziono tego kodu pocztowego w rejestrze`,
  p254: `Atrakcje i usługi`,
  p255: `Wszystko, czego potrzeba, aby w pełni cieszyć się pobytem`,
};
